
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexdSYrybHXr_62XNg122_69sB_aUFa8zmENejPWt71Je8Meta } from "/vercel/path0/apps/site/app/pages/index.vue?macro=true";
import { default as tgvDiUN11vMXIf9BfiqKVchkOwOu6UnvOz7eBu4kZobX4AMeta } from "/vercel/path0/apps/site/app/pages/tgv.vue?macro=true";
import { default as login674ce2nnJIzrZ5US1w8MBMDKIGFWwnBD9Objgh4woYgMeta } from "/vercel/path0/apps/site/app/pages/login.vue?macro=true";
import { default as bonderkZLkuiSZBTMJU9N_QynhhXicXS0s33wDf1q3RDjZqnEMeta } from "/vercel/path0/apps/site/app/pages/bonder.vue?macro=true";
import { default as eventsY6IDnJXcPb0gWxKuTs3Plh7KRPoOIkPDpRoex8kIUC8Meta } from "/vercel/path0/apps/site/app/pages/events.vue?macro=true";
import { default as ownersN6v5I60qLFS8RTsEWvCGmAs3ABboGCURBhs9_xNnAw4Meta } from "/vercel/path0/apps/site/app/pages/owners.vue?macro=true";
import { default as searchUaJ3fe13O3sRLvhQXTfPWa6YMQp_iw0CI8aKhkfiQfgMeta } from "/vercel/path0/apps/site/app/pages/search.vue?macro=true";
import { default as tailorx3EeCGQrLx2YM2eHRoRT63Dh5a_L5Cps8e_kFVDVI8kMeta } from "/vercel/path0/apps/site/app/pages/tailor.vue?macro=true";
import { default as vallatDZlg6oQTHx_9OPj6FERIa8RyWexKvdovMUJp0cirqw4Meta } from "/vercel/path0/apps/site/app/pages/vallat.vue?macro=true";
import { default as contactjUVU4u7wA1nHItt5cml2_OW5TvFJj4wuCKhRFC0otiUMeta } from "/vercel/path0/apps/site/app/pages/contact.vue?macro=true";
import { default as sitemapAr0Hgs3dzbal4NUjFDg4Cycv4uJpEgi7Mck6sG9YlzkMeta } from "/vercel/path0/apps/site/app/pages/sitemap.vue?macro=true";
import { default as addedValuetRv2jq1SsfPM5CVuBrzJGS2UFbq5vnYTtY_NmRr9_PMMeta } from "/vercel/path0/apps/site/app/pages/addedValue.vue?macro=true";
import { default as realEstatevxg1gtlSV1AdhKwoKShEXmzPHiMz8ngh7qv_ChY1XXcMeta } from "/vercel/path0/apps/site/app/pages/realEstate.vue?macro=true";
import { default as inspiration_jZ_L_zrTEbnf9B5Hf5pYFVh7mK_9ZgJaadlPlt5Cl4Meta } from "/vercel/path0/apps/site/app/pages/inspiration.vue?macro=true";
import { default as _91slug_93u0bkzprqkJ9MEgmDgCi8CTVw6hekznGIsYZkJY2rHvkMeta } from "/vercel/path0/apps/site/app/pages/house/[slug].vue?macro=true";
import { default as photosP4CRhQGY9hTY30IVKycMr1o3DBJ8UPF_xJu3SmDUsQMMeta } from "/vercel/path0/apps/site/app/pages/house/photos.vue?macro=true";
import { default as _91id_93cHN_B8VwzEIA6xzggBmpr1FuypaKVVi9q0XQK_3XLxkMeta } from "/vercel/path0/apps/site/app/pages/feedback/[id].vue?macro=true";
import { default as customHolidaysNBqG82K_YUi40FE_ZRIF_OB46YxsVPfv18_CxfTztqQMeta } from "/vercel/path0/apps/site/app/pages/customHolidays.vue?macro=true";
import { default as menuzBkzYEqMCFJAtjSFRQhTPP65fICl_oRGJ98Nk__WUCEMeta } from "/vercel/path0/apps/site/app/pages/myaccount/menu.vue?macro=true";
import { default as travelPartnersadiws7TnHjZ1N_NKFFBYrSbZCLY_4JBvIJVxRN_5WUEMeta } from "/vercel/path0/apps/site/app/pages/travelPartners.vue?macro=true";
import { default as index__OTwtIqL726Gq7S39_orWb9_njRQkbweKWbLnWGwjYMeta } from "/vercel/path0/apps/site/app/pages/wishlist/index.vue?macro=true";
import { default as houseCollection4SiMMlLJimmZsu_lE55DUZWLeh7FhpGASXa9AYojaccMeta } from "/vercel/path0/apps/site/app/pages/houseCollection.vue?macro=true";
import { default as termsOfUseTfWS3l_uc7pBqP_bGvSyihCHzZNV4h9DjNqb28BXxT4Meta } from "/vercel/path0/apps/site/app/pages/legal/termsOfUse.vue?macro=true";
import { default as profileOiYTZNAbbN9SzDMNyH_7Z66XT3VvchIv7VkJP7Y6kREMeta } from "/vercel/path0/apps/site/app/pages/myaccount/profile.vue?macro=true";
import { default as editRpe8PSLdffCr6o5tBaXxz7EyrdtHwIV6kcRqR3Ts2BIMeta } from "/vercel/path0/apps/site/app/pages/stayProposal/edit.vue?macro=true";
import { default as bookingsRAGXL1s_2UX7U7XJCMg_Ivac5YWtHR84qJaJV98IYZ4Meta } from "/vercel/path0/apps/site/app/pages/myaccount/bookings.vue?macro=true";
import { default as realEstateListingsJYmsclk1rmEQJ3UNg355GdyWpcpVpYMm5knYLJYb8_EMeta } from "/vercel/path0/apps/site/app/pages/realEstateListings.vue?macro=true";
import { default as privacyPolicyMJfhqvTzYCeMXbqx7M9vOEU3iafzFIjLuh1VPqZh_gYMeta } from "/vercel/path0/apps/site/app/pages/legal/privacyPolicy.vue?macro=true";
import { default as _91name_93PLF6NcqBkFWmzq2L7kiCaBpJNkPaSC2pDWDVqk_zxnoMeta } from "/vercel/path0/apps/site/app/pages/[destination]/[name].vue?macro=true";
import { default as errorRYNwFWX3cPVndbs4mdiJ9TpPSMNusfvPsUi8xznUW7gMeta } from "/vercel/path0/apps/site/app/pages/house/preorder/error.vue?macro=true";
import { default as index5LHolv5BXRYQU0Xe8EWFltSR_HoJp96Led0QIhpGGP4Meta } from "/vercel/path0/apps/site/app/pages/house/preorder/index.vue?macro=true";
import { default as formRN6QNfRuukfUMVH9PPSHteG4MvGkF4NN3SbqTXRAc4UMeta } from "/vercel/path0/apps/site/app/pages/payment/deposit/[id]/form.vue?macro=true";
import { default as error97jhheMnGiA5kNJLnMf64v9dXStTcHAR58SzG91tUKYMeta } from "/vercel/path0/apps/site/app/pages/payment/deposit/[id]/error.vue?macro=true";
import { default as successTYz5JbfCyECjbcKc3t0kj6gekmjEq13_nXeTJDr3xH8Meta } from "/vercel/path0/apps/site/app/pages/payment/deposit/[id]/success.vue?macro=true";
import { default as _91id_93MPSavtYwirAVy8Fh1T6orLPKVyT3PTO1x3KWlZm1EgsMeta } from "/vercel/path0/apps/site/app/pages/payment/deposit/[id].vue?macro=true";
import { default as villabookXEb4CXRBa9vWjXnswv37_gMMPYcPaGhdz_V63KOFoF8Meta } from "/vercel/path0/apps/site/app/pages/screenshot/villabook.vue?macro=true";
import { default as _91token_93d9Q_T0kpkJcVOVPLUYFq2o8rH2VCx2AOiJ3TCmFBwQIMeta } from "/vercel/path0/apps/site/app/pages/stayProposal/[token].vue?macro=true";
import { default as ownerConditionsYwIZRNC_qqt35MFetZz7PmYfugeRKClo0RC4njzfHXcMeta } from "/vercel/path0/apps/site/app/pages/legal/ownerConditions.vue?macro=true";
import { default as errorTNs8Y5tcC6IrD4Hu3dBHPbKPkYNLdri3aEULBs65qQMMeta } from "/vercel/path0/apps/site/app/pages/payment/[payin]/error.vue?macro=true";
import { default as indexlbS4ZXH6WX_jDSuY9IuL_l1Mdtxja09Yuopv1eUQhGEMeta } from "/vercel/path0/apps/site/app/pages/payment/[payin]/index.vue?macro=true";
import { default as whitebrandz60e4CiP44esLh833cFAp2PQsi6qYlwYLRgkxNUxtQ0Meta } from "/vercel/path0/apps/site/app/pages/screenshot/whitebrand.vue?macro=true";
import { default as successW0E6eACIq1cSGH4cv4zcuKBpEElVplhu1bj2Q2CPhl4Meta } from "/vercel/path0/apps/site/app/pages/house/preorder/success.vue?macro=true";
import { default as clientConditionsu6wxCgY9EkW551aU_YgRMxyfYOw4r0eFT4UN1f8ovDMMeta } from "/vercel/path0/apps/site/app/pages/legal/clientConditions.vue?macro=true";
import { default as indexe69fzGHgl4Ei7aPSc_3yVhHhzhzlPQBXcH_lIKrru6IMeta } from "/vercel/path0/apps/site/app/pages/wishlist/[token]/index.vue?macro=true";
import { default as successc_OV02bl0rfZppw6Jdlv5evRxoPlRmPo00H6vHffTx0Meta } from "/vercel/path0/apps/site/app/pages/payment/[payin]/success.vue?macro=true";
import { default as sharedEiGD2IzBP4AaDtauN_O5l2XNIjNEk_Mxp5i1G8QvUokMeta } from "/vercel/path0/apps/site/app/pages/wishlist/[token]/shared.vue?macro=true";
import { default as _91slug_93y5bnmJ15w0HVTqR0geWogvpDOAbn81hmaVP69nSxIvgMeta } from "/vercel/path0/apps/site/app/pages/house/transaction/[slug].vue?macro=true";
import { default as photosm1yc8T3G5WY1qn7Myy_xvjyza98jFF0f7EKcWehfELAMeta } from "/vercel/path0/apps/site/app/pages/house/transaction/photos.vue?macro=true";
import { default as indexrYqsR3WaVASBgcKapZO4YwrOum035CFdRPOg4QpEaKMMeta } from "/vercel/path0/apps/site/app/pages/myaccount/documents/index.vue?macro=true";
import { default as infoiucu6TYpj1yRQDSjxUAQJXSzKuH5TuC5A8m2rJVXK2sMeta } from "/vercel/path0/apps/site/app/pages/myaccount/property/[name]/info.vue?macro=true";
import { default as salesdQeGpL_oT04pRcX0ZjuGRlKm82O7oqbQ4MeIRhu_OygMeta } from "/vercel/path0/apps/site/app/pages/myaccount/property/[name]/sales.vue?macro=true";
import { default as prices_gGi9I_1s4yoifO862NRyKjDtec7eOKv1HlNOv5NnMoMeta } from "/vercel/path0/apps/site/app/pages/myaccount/property/[name]/prices.vue?macro=true";
import { default as rentals06rIEQWX_Uurt_Vcq8PDxs37qdUZpxIzswyepFpcs_UMeta } from "/vercel/path0/apps/site/app/pages/myaccount/property/[name]/rentals.vue?macro=true";
import { default as calendarEnNdTA6LyXH6niWWUQDwV1gY5L_GQkIDLeQnFNjRTlkMeta } from "/vercel/path0/apps/site/app/pages/myaccount/property/[name]/calendar.vue?macro=true";
import { default as _91name_933V7_X_WRZWCs0Zbi0WHVgr_KmBIP4zGWe88NbfFnIBwMeta } from "/vercel/path0/apps/site/app/pages/myaccount/property/[name].vue?macro=true";
import { default as resumeOwner1TSgo0jMKf_0tuBBAaJ7KLrmt4WNom54hXCJ8tTmwjQMeta } from "/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/resumeOwner.vue?macro=true";
import { default as resumeClientk7GaWnA3CpS95jFny4bEmZHQfo3cfDerwCX2_LlSox0Meta } from "/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/resumeClient.vue?macro=true";
import { default as successOwnerMojyH05U3Tx_tKieBSB7xhaEk5vgfVPNbyskBZ4UmkQMeta } from "/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/successOwner.vue?macro=true";
import { default as successCliente30xjruuepdXgnFcDlXj56WoGmAntedmXFCtSkdiOnAMeta } from "/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/successClient.vue?macro=true";
import { default as identityDocumentA2sNJmXZNCfru8hcbRJEuw1XiYV07cMCk_YuQvx0R1gMeta } from "/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/identityDocument.vue?macro=true";
import { default as clientInformationUHik2f4q6Bl4vwsP0kgNegKJbMfYDt7MCUlCzFygclMMeta } from "/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/clientInformation.vue?macro=true";
import { default as reservationRequestMFgU0fBr9AftGv7h4bMosZrjcBo53grwBzHmxwg8YS8Meta } from "/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/reservationRequest.vue?macro=true";
import { default as bookingConfirmationjR4lwrg27wQn9k2JZK_zf7GQKGCXFn7lGBxcwxZnkK4Meta } from "/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/bookingConfirmation.vue?macro=true";
import { default as _91id_93_oZfJ1pdul6MXZfqrSDIOPy95SwdHKYaRpgc8f3SL44Meta } from "/vercel/path0/apps/site/app/pages/reservationAgreement/[id].vue?macro=true";
import { default as destinationAlert544zTyc8hbhWNJOUn7zcwsPBOgEoCBnGLLFA97adeoAMeta } from "/vercel/path0/apps/site/app/pages/myaccount/destinationAlert.vue?macro=true";
import { default as _91filter_93N_SUbMnXFDMLOb35Y5RERWiUMocW5regVlJ8ewn_SNQMeta } from "/vercel/path0/apps/site/app/pages/[destination]/[slug]/[filter].vue?macro=true";
import { default as _91id_93mmPadcW_x4UgBZjmCybWcGaprlbc_UNDIaTnZKfybZIMeta } from "/vercel/path0/apps/site/app/pages/myaccount/documents/checks/[id].vue?macro=true";
import { default as contractsxbhboZYSybBLCrFrG2Cyk6OHx8KWy8COu3X1AIIVFWMMeta } from "/vercel/path0/apps/site/app/pages/myaccount/documents/[house]/contracts.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexdSYrybHXr_62XNg122_69sB_aUFa8zmENejPWt71Je8Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/index.vue")
  },
  {
    name: "tgv___fr",
    path: "/fr/the-greek-villas",
    meta: tgvDiUN11vMXIf9BfiqKVchkOwOu6UnvOz7eBu4kZobX4AMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/tgv.vue")
  },
  {
    name: "tgv___en",
    path: "/en/the-greek-villas",
    meta: tgvDiUN11vMXIf9BfiqKVchkOwOu6UnvOz7eBu4kZobX4AMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/tgv.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexdSYrybHXr_62XNg122_69sB_aUFa8zmENejPWt71Je8Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexdSYrybHXr_62XNg122_69sB_aUFa8zmENejPWt71Je8Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/index.vue")
  },
  {
    name: "login___fr",
    path: "/fr/connexion",
    meta: { ...(login674ce2nnJIzrZ5US1w8MBMDKIGFWwnBD9Objgh4woYgMeta || {}), ...{"middleware":["login"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: { ...(login674ce2nnJIzrZ5US1w8MBMDKIGFWwnBD9Objgh4woYgMeta || {}), ...{"middleware":["login"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/login.vue")
  },
  {
    name: "bonder___fr",
    path: "/fr/bonderco",
    meta: bonderkZLkuiSZBTMJU9N_QynhhXicXS0s33wDf1q3RDjZqnEMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/bonder.vue")
  },
  {
    name: "bonder___en",
    path: "/en/bonderco",
    meta: bonderkZLkuiSZBTMJU9N_QynhhXicXS0s33wDf1q3RDjZqnEMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/bonder.vue")
  },
  {
    name: "events___fr",
    path: "/fr/service-evenementiel",
    meta: eventsY6IDnJXcPb0gWxKuTs3Plh7KRPoOIkPDpRoex8kIUC8Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/events.vue")
  },
  {
    name: "events___en",
    path: "/en/event-service",
    meta: eventsY6IDnJXcPb0gWxKuTs3Plh7KRPoOIkPDpRoex8kIUC8Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/events.vue")
  },
  {
    name: "owners___fr",
    path: "/fr/proprietaires",
    meta: ownersN6v5I60qLFS8RTsEWvCGmAs3ABboGCURBhs9_xNnAw4Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/owners.vue")
  },
  {
    name: "owners___en",
    path: "/en/owners",
    meta: ownersN6v5I60qLFS8RTsEWvCGmAs3ABboGCURBhs9_xNnAw4Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/owners.vue")
  },
  {
    name: "search___fr",
    path: "/fr/recherche",
    meta: searchUaJ3fe13O3sRLvhQXTfPWa6YMQp_iw0CI8aKhkfiQfgMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    meta: searchUaJ3fe13O3sRLvhQXTfPWa6YMQp_iw0CI8aKhkfiQfgMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/search.vue")
  },
  {
    name: "tailor___fr",
    path: "/fr/notre-conciergerie-de-luxe",
    meta: tailorx3EeCGQrLx2YM2eHRoRT63Dh5a_L5Cps8e_kFVDVI8kMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/tailor.vue")
  },
  {
    name: "tailor___en",
    path: "/en/our-luxury-concierge-service",
    meta: tailorx3EeCGQrLx2YM2eHRoRT63Dh5a_L5Cps8e_kFVDVI8kMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/tailor.vue")
  },
  {
    name: "vallat___fr",
    path: "/fr/vallat",
    meta: vallatDZlg6oQTHx_9OPj6FERIa8RyWexKvdovMUJp0cirqw4Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/vallat.vue")
  },
  {
    name: "vallat___en",
    path: "/en/vallat",
    meta: vallatDZlg6oQTHx_9OPj6FERIa8RyWexKvdovMUJp0cirqw4Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/vallat.vue")
  },
  {
    name: "contact___fr",
    path: "/fr/contact",
    meta: contactjUVU4u7wA1nHItt5cml2_OW5TvFJj4wuCKhRFC0otiUMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    meta: contactjUVU4u7wA1nHItt5cml2_OW5TvFJj4wuCKhRFC0otiUMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/contact.vue")
  },
  {
    name: "sitemap___fr",
    path: "/fr/plan-du-site",
    meta: sitemapAr0Hgs3dzbal4NUjFDg4Cycv4uJpEgi7Mck6sG9YlzkMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/sitemap.vue")
  },
  {
    name: "sitemap___en",
    path: "/en/sitemap",
    meta: sitemapAr0Hgs3dzbal4NUjFDg4Cycv4uJpEgi7Mck6sG9YlzkMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/sitemap.vue")
  },
  {
    name: "addedValue___fr",
    path: "/fr/notre-valeur-ajoutee",
    meta: addedValuetRv2jq1SsfPM5CVuBrzJGS2UFbq5vnYTtY_NmRr9_PMMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/addedValue.vue")
  },
  {
    name: "addedValue___en",
    path: "/en/our-added-value",
    meta: addedValuetRv2jq1SsfPM5CVuBrzJGS2UFbq5vnYTtY_NmRr9_PMMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/addedValue.vue")
  },
  {
    name: "realEstate___fr",
    path: "/fr/immobilier-luxe-service",
    meta: realEstatevxg1gtlSV1AdhKwoKShEXmzPHiMz8ngh7qv_ChY1XXcMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/realEstate.vue")
  },
  {
    name: "realEstate___en",
    path: "/en/luxury-real-estate-service",
    meta: realEstatevxg1gtlSV1AdhKwoKShEXmzPHiMz8ngh7qv_ChY1XXcMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/realEstate.vue")
  },
  {
    name: "inspiration___fr",
    path: "/fr/s-inspirer",
    meta: inspiration_jZ_L_zrTEbnf9B5Hf5pYFVh7mK_9ZgJaadlPlt5Cl4Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/inspiration.vue")
  },
  {
    name: "inspiration___en",
    path: "/en/get-inspired",
    meta: inspiration_jZ_L_zrTEbnf9B5Hf5pYFVh7mK_9ZgJaadlPlt5Cl4Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/inspiration.vue")
  },
  {
    name: "house-slug___fr",
    path: "/fr/location-luxe/:slug()",
    meta: { ...(_91slug_93u0bkzprqkJ9MEgmDgCi8CTVw6hekznGIsYZkJY2rHvkMeta || {}), ...{"middleware":["house"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/house/[slug].vue")
  },
  {
    name: "house-slug___en",
    path: "/en/luxury-rental/:slug()",
    meta: { ...(_91slug_93u0bkzprqkJ9MEgmDgCi8CTVw6hekznGIsYZkJY2rHvkMeta || {}), ...{"middleware":["house"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/house/[slug].vue")
  },
  {
    name: "house-photos___fr",
    path: "/fr/location-luxe/:slug()/photos",
    meta: { ...(photosP4CRhQGY9hTY30IVKycMr1o3DBJ8UPF_xJu3SmDUsQMMeta || {}), ...{"middleware":["house"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/house/photos.vue")
  },
  {
    name: "house-photos___en",
    path: "/en/luxury-rental/:slug()/photos",
    meta: { ...(photosP4CRhQGY9hTY30IVKycMr1o3DBJ8UPF_xJu3SmDUsQMMeta || {}), ...{"middleware":["house"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/house/photos.vue")
  },
  {
    name: "feedback-id___fr",
    path: "/fr/formulaire-de-satisfaction/:id()",
    component: () => import("/vercel/path0/apps/site/app/pages/feedback/[id].vue")
  },
  {
    name: "feedback-id___en",
    path: "/en/feedback/:id()",
    component: () => import("/vercel/path0/apps/site/app/pages/feedback/[id].vue")
  },
  {
    name: "customHolidays___fr",
    path: "/fr/vacances-sur-mesure",
    meta: customHolidaysNBqG82K_YUi40FE_ZRIF_OB46YxsVPfv18_CxfTztqQMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/customHolidays.vue")
  },
  {
    name: "customHolidays___en",
    path: "/en/custom-holidays",
    meta: customHolidaysNBqG82K_YUi40FE_ZRIF_OB46YxsVPfv18_CxfTztqQMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/customHolidays.vue")
  },
  {
    name: "myaccount-menu___fr",
    path: "/fr/mon-compte/menu",
    meta: menuzBkzYEqMCFJAtjSFRQhTPP65fICl_oRGJ98Nk__WUCEMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/menu.vue")
  },
  {
    name: "myaccount-menu___en",
    path: "/en/my-account/menu",
    meta: menuzBkzYEqMCFJAtjSFRQhTPP65fICl_oRGJ98Nk__WUCEMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/menu.vue")
  },
  {
    name: "travelPartners___fr",
    path: "/fr/agences-partenaires",
    meta: travelPartnersadiws7TnHjZ1N_NKFFBYrSbZCLY_4JBvIJVxRN_5WUEMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/travelPartners.vue")
  },
  {
    name: "travelPartners___en",
    path: "/en/travel-partners",
    meta: travelPartnersadiws7TnHjZ1N_NKFFBYrSbZCLY_4JBvIJVxRN_5WUEMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/travelPartners.vue")
  },
  {
    name: "wishlist___fr",
    path: "/fr/wishlist",
    meta: { ...(index__OTwtIqL726Gq7S39_orWb9_njRQkbweKWbLnWGwjYMeta || {}), ...{"middleware":["redirect-wishlist"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/wishlist/index.vue")
  },
  {
    name: "wishlist___en",
    path: "/en/wishlist",
    meta: { ...(index__OTwtIqL726Gq7S39_orWb9_njRQkbweKWbLnWGwjYMeta || {}), ...{"middleware":["redirect-wishlist"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/wishlist/index.vue")
  },
  {
    name: "houseCollection___fr",
    path: "/fr/collection-de-maisons",
    component: () => import("/vercel/path0/apps/site/app/pages/houseCollection.vue")
  },
  {
    name: "houseCollection___en",
    path: "/en/collection-of-houses",
    component: () => import("/vercel/path0/apps/site/app/pages/houseCollection.vue")
  },
  {
    name: "legal-termsOfUse___fr",
    path: "/fr/conditions-generales-utilisation",
    meta: termsOfUseTfWS3l_uc7pBqP_bGvSyihCHzZNV4h9DjNqb28BXxT4Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/legal/termsOfUse.vue")
  },
  {
    name: "legal-termsOfUse___en",
    path: "/en/terms-of-use",
    meta: termsOfUseTfWS3l_uc7pBqP_bGvSyihCHzZNV4h9DjNqb28BXxT4Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/legal/termsOfUse.vue")
  },
  {
    name: "myaccount-profile___fr",
    path: "/fr/mon-compte/profil",
    meta: profileOiYTZNAbbN9SzDMNyH_7Z66XT3VvchIv7VkJP7Y6kREMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/profile.vue")
  },
  {
    name: "myaccount-profile___en",
    path: "/en/my-account/profile",
    meta: profileOiYTZNAbbN9SzDMNyH_7Z66XT3VvchIv7VkJP7Y6kREMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/profile.vue")
  },
  {
    name: "stayProposal-edit___fr",
    path: "/fr/modifier-proposition-de-sejour",
    meta: { ...(editRpe8PSLdffCr6o5tBaXxz7EyrdtHwIV6kcRqR3Ts2BIMeta || {}), ...{"middleware":["stay-proposal-edit"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/stayProposal/edit.vue")
  },
  {
    name: "stayProposal-edit___en",
    path: "/en/edit-stay-proposal",
    meta: { ...(editRpe8PSLdffCr6o5tBaXxz7EyrdtHwIV6kcRqR3Ts2BIMeta || {}), ...{"middleware":["stay-proposal-edit"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/stayProposal/edit.vue")
  },
  {
    name: "myaccount-bookings___fr",
    path: "/fr/mon-compte/reservations",
    meta: bookingsRAGXL1s_2UX7U7XJCMg_Ivac5YWtHR84qJaJV98IYZ4Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/bookings.vue")
  },
  {
    name: "myaccount-bookings___en",
    path: "/en/my-account/bookings",
    meta: bookingsRAGXL1s_2UX7U7XJCMg_Ivac5YWtHR84qJaJV98IYZ4Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/bookings.vue")
  },
  {
    name: "realEstateListings___fr",
    path: "/fr/immobilier-luxe-annonces",
    meta: realEstateListingsJYmsclk1rmEQJ3UNg355GdyWpcpVpYMm5knYLJYb8_EMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/realEstateListings.vue")
  },
  {
    name: "realEstateListings___en",
    path: "/en/luxury-real-estate-listing",
    meta: realEstateListingsJYmsclk1rmEQJ3UNg355GdyWpcpVpYMm5knYLJYb8_EMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/realEstateListings.vue")
  },
  {
    name: "legal-privacyPolicy___fr",
    path: "/fr/politique-confidentialite",
    meta: privacyPolicyMJfhqvTzYCeMXbqx7M9vOEU3iafzFIjLuh1VPqZh_gYMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/legal/privacyPolicy.vue")
  },
  {
    name: "legal-privacyPolicy___en",
    path: "/en/privacy-policy",
    meta: privacyPolicyMJfhqvTzYCeMXbqx7M9vOEU3iafzFIjLuh1VPqZh_gYMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/legal/privacyPolicy.vue")
  },
  {
    name: "destination-name___fr",
    path: "/fr/:destination()/:name()",
    meta: {"middleware":["search-destination-validation"]},
    component: () => import("/vercel/path0/apps/site/app/pages/[destination]/[name].vue")
  },
  {
    name: "destination-name___en",
    path: "/en/:destination()/:name()",
    meta: {"middleware":["search-destination-validation"]},
    component: () => import("/vercel/path0/apps/site/app/pages/[destination]/[name].vue")
  },
  {
    name: "house-preorder-error___fr",
    path: "/fr/location-luxe/:slug()/pose-d-option/erreur",
    meta: errorRYNwFWX3cPVndbs4mdiJ9TpPSMNusfvPsUi8xznUW7gMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/house/preorder/error.vue")
  },
  {
    name: "house-preorder-error___en",
    path: "/en/luxury-rental/:slug()/pre-order/error",
    meta: errorRYNwFWX3cPVndbs4mdiJ9TpPSMNusfvPsUi8xznUW7gMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/house/preorder/error.vue")
  },
  {
    name: "house-preorder___fr",
    path: "/fr/location-luxe/:slug()/pose-d-option",
    meta: index5LHolv5BXRYQU0Xe8EWFltSR_HoJp96Led0QIhpGGP4Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/house/preorder/index.vue")
  },
  {
    name: "house-preorder___en",
    path: "/en/luxury-rental/:slug()/pre-order",
    meta: index5LHolv5BXRYQU0Xe8EWFltSR_HoJp96Led0QIhpGGP4Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/house/preorder/index.vue")
  },
  {
    name: "payment-deposit-id___fr",
    path: "/fr/payment/deposit/:id()",
    meta: _91id_93MPSavtYwirAVy8Fh1T6orLPKVyT3PTO1x3KWlZm1EgsMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/payment/deposit/[id].vue"),
    children: [
  {
    name: "payment-deposit-id-form___fr",
    path: "/fr/paiements/caution/:id()",
    meta: formRN6QNfRuukfUMVH9PPSHteG4MvGkF4NN3SbqTXRAc4UMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/payment/deposit/[id]/form.vue")
  },
  {
    name: "payment-deposit-id-error___fr",
    path: "/fr/paiements/caution/:id()/erreur",
    meta: error97jhheMnGiA5kNJLnMf64v9dXStTcHAR58SzG91tUKYMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/payment/deposit/[id]/error.vue")
  },
  {
    name: "payment-deposit-id-success___fr",
    path: "/fr/paiements/caution/:id()/succes",
    meta: successTYz5JbfCyECjbcKc3t0kj6gekmjEq13_nXeTJDr3xH8Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/payment/deposit/[id]/success.vue")
  }
]
  },
  {
    name: "payment-deposit-id___en",
    path: "/en/payment/deposit/:id()",
    meta: _91id_93MPSavtYwirAVy8Fh1T6orLPKVyT3PTO1x3KWlZm1EgsMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/payment/deposit/[id].vue"),
    children: [
  {
    name: "payment-deposit-id-form___en",
    path: "/en/payments/deposit/:id()",
    meta: formRN6QNfRuukfUMVH9PPSHteG4MvGkF4NN3SbqTXRAc4UMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/payment/deposit/[id]/form.vue")
  },
  {
    name: "payment-deposit-id-error___en",
    path: "/en/payments/deposit/:id()/error",
    meta: error97jhheMnGiA5kNJLnMf64v9dXStTcHAR58SzG91tUKYMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/payment/deposit/[id]/error.vue")
  },
  {
    name: "payment-deposit-id-success___en",
    path: "/en/payments/deposit/:id()/success",
    meta: successTYz5JbfCyECjbcKc3t0kj6gekmjEq13_nXeTJDr3xH8Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/payment/deposit/[id]/success.vue")
  }
]
  },
  {
    name: "screenshot-villabook___fr",
    path: "/fr/villabook/:id()",
    meta: villabookXEb4CXRBa9vWjXnswv37_gMMPYcPaGhdz_V63KOFoF8Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/screenshot/villabook.vue")
  },
  {
    name: "screenshot-villabook___en",
    path: "/en/villabook/:id()",
    meta: villabookXEb4CXRBa9vWjXnswv37_gMMPYcPaGhdz_V63KOFoF8Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/screenshot/villabook.vue")
  },
  {
    name: "stayProposal-token___fr",
    path: "/fr/proposition-de-sejour/:token()",
    meta: _91token_93d9Q_T0kpkJcVOVPLUYFq2o8rH2VCx2AOiJ3TCmFBwQIMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/stayProposal/[token].vue")
  },
  {
    name: "stayProposal-token___en",
    path: "/en/stay-proposal/:token()",
    meta: _91token_93d9Q_T0kpkJcVOVPLUYFq2o8rH2VCx2AOiJ3TCmFBwQIMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/stayProposal/[token].vue")
  },
  {
    name: "legal-ownerConditions___fr",
    path: "/fr/conditions-proprietaire",
    meta: ownerConditionsYwIZRNC_qqt35MFetZz7PmYfugeRKClo0RC4njzfHXcMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/legal/ownerConditions.vue")
  },
  {
    name: "legal-ownerConditions___en",
    path: "/en/owner-conditions",
    meta: ownerConditionsYwIZRNC_qqt35MFetZz7PmYfugeRKClo0RC4njzfHXcMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/legal/ownerConditions.vue")
  },
  {
    name: "payment-payin-error___fr",
    path: "/fr/paiements/:payin()/erreur",
    meta: errorTNs8Y5tcC6IrD4Hu3dBHPbKPkYNLdri3aEULBs65qQMMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/payment/[payin]/error.vue")
  },
  {
    name: "payment-payin-error___en",
    path: "/en/payments/:payin()/error",
    meta: errorTNs8Y5tcC6IrD4Hu3dBHPbKPkYNLdri3aEULBs65qQMMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/payment/[payin]/error.vue")
  },
  {
    name: "payment-payin___fr",
    path: "/fr/paiements/:payin()",
    meta: indexlbS4ZXH6WX_jDSuY9IuL_l1Mdtxja09Yuopv1eUQhGEMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/payment/[payin]/index.vue")
  },
  {
    name: "payment-payin___en",
    path: "/en/payments/:payin()",
    meta: indexlbS4ZXH6WX_jDSuY9IuL_l1Mdtxja09Yuopv1eUQhGEMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/payment/[payin]/index.vue")
  },
  {
    name: "screenshot-whitebrand___fr",
    path: "/fr/preview/:id()",
    meta: whitebrandz60e4CiP44esLh833cFAp2PQsi6qYlwYLRgkxNUxtQ0Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/screenshot/whitebrand.vue")
  },
  {
    name: "screenshot-whitebrand___en",
    path: "/en/preview/:id()",
    meta: whitebrandz60e4CiP44esLh833cFAp2PQsi6qYlwYLRgkxNUxtQ0Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/screenshot/whitebrand.vue")
  },
  {
    name: "house-preorder-success___fr",
    path: "/fr/location-luxe/:slug()/pose-d-option/succes",
    meta: successW0E6eACIq1cSGH4cv4zcuKBpEElVplhu1bj2Q2CPhl4Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/house/preorder/success.vue")
  },
  {
    name: "house-preorder-success___en",
    path: "/en/luxury-rental/:slug()/pre-order/success",
    meta: successW0E6eACIq1cSGH4cv4zcuKBpEElVplhu1bj2Q2CPhl4Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/house/preorder/success.vue")
  },
  {
    name: "legal-clientConditions___fr",
    path: "/fr/conditions-client",
    meta: clientConditionsu6wxCgY9EkW551aU_YgRMxyfYOw4r0eFT4UN1f8ovDMMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/legal/clientConditions.vue")
  },
  {
    name: "legal-clientConditions___en",
    path: "/en/client-conditions",
    meta: clientConditionsu6wxCgY9EkW551aU_YgRMxyfYOw4r0eFT4UN1f8ovDMMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/legal/clientConditions.vue")
  },
  {
    name: "wishlist-token___fr",
    path: "/fr/wishlist/:token()",
    meta: indexe69fzGHgl4Ei7aPSc_3yVhHhzhzlPQBXcH_lIKrru6IMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/wishlist/[token]/index.vue")
  },
  {
    name: "wishlist-token___en",
    path: "/en/wishlist/:token()",
    meta: indexe69fzGHgl4Ei7aPSc_3yVhHhzhzlPQBXcH_lIKrru6IMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/wishlist/[token]/index.vue")
  },
  {
    name: "payment-payin-success___fr",
    path: "/fr/paiements/:payin()/succes",
    meta: successc_OV02bl0rfZppw6Jdlv5evRxoPlRmPo00H6vHffTx0Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/payment/[payin]/success.vue")
  },
  {
    name: "payment-payin-success___en",
    path: "/en/payments/:payin()/success",
    meta: successc_OV02bl0rfZppw6Jdlv5evRxoPlRmPo00H6vHffTx0Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/payment/[payin]/success.vue")
  },
  {
    name: "wishlist-token-shared___fr",
    path: "/fr/wishlist/:token()/partage",
    meta: sharedEiGD2IzBP4AaDtauN_O5l2XNIjNEk_Mxp5i1G8QvUokMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/wishlist/[token]/shared.vue")
  },
  {
    name: "wishlist-token-shared___en",
    path: "/en/wishlist/:token()/shared",
    meta: sharedEiGD2IzBP4AaDtauN_O5l2XNIjNEk_Mxp5i1G8QvUokMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/wishlist/[token]/shared.vue")
  },
  {
    name: "house-transaction-slug___fr",
    path: "/fr/immobilier-luxe/:slug()",
    meta: { ...(_91slug_93y5bnmJ15w0HVTqR0geWogvpDOAbn81hmaVP69nSxIvgMeta || {}), ...{"middleware":["house-transaction"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/house/transaction/[slug].vue")
  },
  {
    name: "house-transaction-slug___en",
    path: "/en/luxury-real-estate/:slug()",
    meta: { ...(_91slug_93y5bnmJ15w0HVTqR0geWogvpDOAbn81hmaVP69nSxIvgMeta || {}), ...{"middleware":["house-transaction"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/house/transaction/[slug].vue")
  },
  {
    name: "house-transaction-photos___fr",
    path: "/fr/immobilier-luxe/:slug()/photos",
    meta: { ...(photosm1yc8T3G5WY1qn7Myy_xvjyza98jFF0f7EKcWehfELAMeta || {}), ...{"middleware":["house-transaction"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/house/transaction/photos.vue")
  },
  {
    name: "house-transaction-photos___en",
    path: "/en/luxury-real-estate/:slug()/photos",
    meta: { ...(photosm1yc8T3G5WY1qn7Myy_xvjyza98jFF0f7EKcWehfELAMeta || {}), ...{"middleware":["house-transaction"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/house/transaction/photos.vue")
  },
  {
    name: "myaccount-documents___fr",
    path: "/fr/mon-compte/documents",
    meta: indexrYqsR3WaVASBgcKapZO4YwrOum035CFdRPOg4QpEaKMMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/documents/index.vue")
  },
  {
    name: "myaccount-documents___en",
    path: "/en/my-account/documents",
    meta: indexrYqsR3WaVASBgcKapZO4YwrOum035CFdRPOg4QpEaKMMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/documents/index.vue")
  },
  {
    name: "myaccount-property-name___fr",
    path: "/fr/mon-compte/proprietes/:name()",
    meta: { ...(_91name_933V7_X_WRZWCs0Zbi0WHVgr_KmBIP4zGWe88NbfFnIBwMeta || {}), ...{"middleware":["unapproved-contract-information"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/property/[name].vue"),
    children: [
  {
    name: "myaccount-property-name-info___fr",
    path: "informations-contrat",
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/property/[name]/info.vue")
  },
  {
    name: "myaccount-property-name-sales___fr",
    path: "ventes",
    meta: {"middleware":["property-sales"]},
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/property/[name]/sales.vue")
  },
  {
    name: "myaccount-property-name-prices___fr",
    path: "prix",
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/property/[name]/prices.vue")
  },
  {
    name: "myaccount-property-name-rentals___fr",
    path: "locations",
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/property/[name]/rentals.vue")
  },
  {
    name: "myaccount-property-name-calendar___fr",
    path: "calendrier",
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/property/[name]/calendar.vue")
  }
]
  },
  {
    name: "myaccount-property-name___en",
    path: "/en/my-account/properties/:name()",
    meta: { ...(_91name_933V7_X_WRZWCs0Zbi0WHVgr_KmBIP4zGWe88NbfFnIBwMeta || {}), ...{"middleware":["unapproved-contract-information"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/property/[name].vue"),
    children: [
  {
    name: "myaccount-property-name-info___en",
    path: "contract-information",
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/property/[name]/info.vue")
  },
  {
    name: "myaccount-property-name-sales___en",
    path: "sales",
    meta: {"middleware":["property-sales"]},
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/property/[name]/sales.vue")
  },
  {
    name: "myaccount-property-name-prices___en",
    path: "prices",
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/property/[name]/prices.vue")
  },
  {
    name: "myaccount-property-name-rentals___en",
    path: "rentals",
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/property/[name]/rentals.vue")
  },
  {
    name: "myaccount-property-name-calendar___en",
    path: "calendar",
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/property/[name]/calendar.vue")
  }
]
  },
  {
    name: "reservationAgreement-id___fr",
    path: "/fr/reservationAgreement/:id()",
    meta: _91id_93_oZfJ1pdul6MXZfqrSDIOPy95SwdHKYaRpgc8f3SL44Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id].vue"),
    children: [
  {
    name: "reservationAgreement-id-resumeOwner___fr",
    path: "/fr/demande-de-reservation/:id()/recapitulatif",
    meta: resumeOwner1TSgo0jMKf_0tuBBAaJ7KLrmt4WNom54hXCJ8tTmwjQMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/resumeOwner.vue")
  },
  {
    name: "reservationAgreement-id-resumeClient___fr",
    path: "/fr/contrat-de-location/:id()/recapitulatif",
    meta: resumeClientk7GaWnA3CpS95jFny4bEmZHQfo3cfDerwCX2_LlSox0Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/resumeClient.vue")
  },
  {
    name: "reservationAgreement-id-successOwner___fr",
    path: "/fr/demande-de-reservation/:id()/accepter",
    meta: successOwnerMojyH05U3Tx_tKieBSB7xhaEk5vgfVPNbyskBZ4UmkQMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/successOwner.vue")
  },
  {
    name: "reservationAgreement-id-successClient___fr",
    path: "/fr/contrat-de-location/:id()/paiement",
    meta: successCliente30xjruuepdXgnFcDlXj56WoGmAntedmXFCtSkdiOnAMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/successClient.vue")
  },
  {
    name: "reservationAgreement-id-identityDocument___fr",
    path: "/fr/contrat-de-location/:id()/document-identite",
    meta: identityDocumentA2sNJmXZNCfru8hcbRJEuw1XiYV07cMCk_YuQvx0R1gMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/identityDocument.vue")
  },
  {
    name: "reservationAgreement-id-clientInformation___fr",
    path: "/fr/contrat-de-location/:id()/information-client",
    meta: clientInformationUHik2f4q6Bl4vwsP0kgNegKJbMfYDt7MCUlCzFygclMMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/clientInformation.vue")
  },
  {
    name: "reservationAgreement-id-reservationRequest___fr",
    path: "/fr/demande-de-reservation/:id()/confirmer",
    meta: reservationRequestMFgU0fBr9AftGv7h4bMosZrjcBo53grwBzHmxwg8YS8Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/reservationRequest.vue")
  },
  {
    name: "reservationAgreement-id-bookingConfirmation___fr",
    path: "/fr/contrat-de-location/:id()/confirmer",
    meta: bookingConfirmationjR4lwrg27wQn9k2JZK_zf7GQKGCXFn7lGBxcwxZnkK4Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/bookingConfirmation.vue")
  }
]
  },
  {
    name: "reservationAgreement-id___en",
    path: "/en/reservationAgreement/:id()",
    meta: _91id_93_oZfJ1pdul6MXZfqrSDIOPy95SwdHKYaRpgc8f3SL44Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id].vue"),
    children: [
  {
    name: "reservationAgreement-id-resumeOwner___en",
    path: "/en/reservation-request/:id()/resume",
    meta: resumeOwner1TSgo0jMKf_0tuBBAaJ7KLrmt4WNom54hXCJ8tTmwjQMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/resumeOwner.vue")
  },
  {
    name: "reservationAgreement-id-resumeClient___en",
    path: "/en/rental-contract/:id()/resume",
    meta: resumeClientk7GaWnA3CpS95jFny4bEmZHQfo3cfDerwCX2_LlSox0Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/resumeClient.vue")
  },
  {
    name: "reservationAgreement-id-successOwner___en",
    path: "/en/reservation-request/:id()/accept-client",
    meta: successOwnerMojyH05U3Tx_tKieBSB7xhaEk5vgfVPNbyskBZ4UmkQMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/successOwner.vue")
  },
  {
    name: "reservationAgreement-id-successClient___en",
    path: "/en/rental-contract/:id()/payment",
    meta: successCliente30xjruuepdXgnFcDlXj56WoGmAntedmXFCtSkdiOnAMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/successClient.vue")
  },
  {
    name: "reservationAgreement-id-identityDocument___en",
    path: "/en/rental-contract/:id()/identity-documents",
    meta: identityDocumentA2sNJmXZNCfru8hcbRJEuw1XiYV07cMCk_YuQvx0R1gMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/identityDocument.vue")
  },
  {
    name: "reservationAgreement-id-clientInformation___en",
    path: "/en/rental-contract/:id()/client-information",
    meta: clientInformationUHik2f4q6Bl4vwsP0kgNegKJbMfYDt7MCUlCzFygclMMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/clientInformation.vue")
  },
  {
    name: "reservationAgreement-id-reservationRequest___en",
    path: "/en/reservation-request/:id()/confirm",
    meta: reservationRequestMFgU0fBr9AftGv7h4bMosZrjcBo53grwBzHmxwg8YS8Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/reservationRequest.vue")
  },
  {
    name: "reservationAgreement-id-bookingConfirmation___en",
    path: "/en/rental-contract/:id()/confirmation",
    meta: bookingConfirmationjR4lwrg27wQn9k2JZK_zf7GQKGCXFn7lGBxcwxZnkK4Meta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/reservationAgreement/[id]/bookingConfirmation.vue")
  }
]
  },
  {
    name: "myaccount-destinationAlert___fr",
    path: "/fr/mon-compte/mes-alertes-destination",
    meta: destinationAlert544zTyc8hbhWNJOUn7zcwsPBOgEoCBnGLLFA97adeoAMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/destinationAlert.vue")
  },
  {
    name: "myaccount-destinationAlert___en",
    path: "/en/my-account/my-destination-alerts",
    meta: destinationAlert544zTyc8hbhWNJOUn7zcwsPBOgEoCBnGLLFA97adeoAMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/destinationAlert.vue")
  },
  {
    name: "destination-slug-filter___fr",
    path: "/fr/:destination()/:slug()/:filter()",
    meta: { ...(_91filter_93N_SUbMnXFDMLOb35Y5RERWiUMocW5regVlJ8ewn_SNQMeta || {}), ...{"middleware":["search-destination-filter-validation"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/[destination]/[slug]/[filter].vue")
  },
  {
    name: "destination-slug-filter___en",
    path: "/en/:destination()/:slug()/:filter()",
    meta: { ...(_91filter_93N_SUbMnXFDMLOb35Y5RERWiUMocW5regVlJ8ewn_SNQMeta || {}), ...{"middleware":["search-destination-filter-validation"]} },
    component: () => import("/vercel/path0/apps/site/app/pages/[destination]/[slug]/[filter].vue")
  },
  {
    name: "myaccount-documents-checks-id___fr",
    path: "/fr/mon-compte/documents/checks/:id()",
    meta: _91id_93mmPadcW_x4UgBZjmCybWcGaprlbc_UNDIaTnZKfybZIMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/documents/checks/[id].vue")
  },
  {
    name: "myaccount-documents-checks-id___en",
    path: "/en/my-account/documents/checks/:id()",
    meta: _91id_93mmPadcW_x4UgBZjmCybWcGaprlbc_UNDIaTnZKfybZIMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/documents/checks/[id].vue")
  },
  {
    name: "myaccount-documents-house-contracts___fr",
    path: "/fr/mon-compte/documents/:houseId()/contrats",
    meta: contractsxbhboZYSybBLCrFrG2Cyk6OHx8KWy8COu3X1AIIVFWMMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/documents/[house]/contracts.vue")
  },
  {
    name: "myaccount-documents-house-contracts___en",
    path: "/en/my-account/documents/:houseId()/contracts",
    meta: contractsxbhboZYSybBLCrFrG2Cyk6OHx8KWy8COu3X1AIIVFWMMeta || {},
    component: () => import("/vercel/path0/apps/site/app/pages/myaccount/documents/[house]/contracts.vue")
  }
]